function Purchases() {
  return (
    <main className="container-fluid dashboard">
      <div className="row m-3">
        <div className="row justify-content-around tble">
          <div className="col-6">
            <h3 className="dashboard-title">Purchases </h3>
          </div>
          <div className="mr-auto col-6 text-end">
            <button
              type="button"
              className="mr-auto btn btn-purple-bg"
              onClick={() => {}}
            >
              + Add Purchase
            </button>
          </div>
        </div>
      </div>

      <div className="row m-3"></div>
    </main>
  );
}
export default Purchases;
